<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
    <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
      @if (status) {
        <span><i class="fas fa-angle-right"></i></span>
      }

      @if (!status) {
        <span><i class="fas fa-angle-left"></i></span>
      }
    </div>
    <div class="sidebar-header">
      <h3>{{'NavMenu.Aboutus'|translate}}</h3>
    </div>

    <ul class="list-unstyled components">

      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.Meetthe'|translate}}" routerLink="meet-the-assessor">{{'NavMenu.Meetthe'|translate}}</a>
      </li>
      <!--<li>
      <a routerLinkActive="active-tab" (click)="status=!status" routerLink="disabled-veterans">{{'NavMenu.AssessorOffice'|translate}}</a>
    </li>-->
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.MeettheStaff'|translate}}" routerLink="meet-the-staff">{{'NavMenu.MeettheStaff'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.Proptax'|translate}}" routerLink="property-tax-system">{{'NavMenu.Proptax'|translate}}</a>
    </li>




  </ul>

</nav>
<div id="content">

  <!-- <button type="button" id="sidebarCollapse" (click)="status=!status" class="btn btn-info">
  <i class="fas fa-align-left"></i>
  <span>Toggle Sidebar</span>
</button> -->
<router-outlet></router-outlet>
</div>


</div>
